// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__5l5GL","actionsCol":"EnrolledClinics_actionsCol__1FdGL"};